import React from 'react';
import { formatBannerMessage, formatDateFr } from '../../utils/bannerFormat';

// Les dates sont obligatoires côté panel admin : le texte s'adapte automatiquement
// selon qu'on est avant la période ("à venir") ou dedans ("actuellement fermé").
export default function VacationPopup({ banner, onClose }) {
  const today = new Date().toISOString().slice(0, 10);
  const isUpcoming = today < banner.start_date;
  const dateLabel = isUpcoming
    ? `${formatDateFr(banner.start_date)} → ${formatDateFr(banner.end_date)}`
    : formatDateFr(banner.end_date);
  const eyebrow = isUpcoming ? 'SDN fera une pause' : 'SDN fait une pause';

  return (
    <div className="vacation-popup-overlay" onClick={onClose}>
      <div className="vacation-popup-box" onClick={(e) => e.stopPropagation()}>
        <button className="vacation-popup-close" onClick={onClose} aria-label="Fermer">✕</button>
        <div className="vacation-popup-eyebrow">{eyebrow}</div>
        <p
          className="vacation-popup-message"
          dangerouslySetInnerHTML={{ __html: formatBannerMessage(banner.message) }}
        />
        <div className={`vacation-popup-date-badge ${isUpcoming ? 'is-upcoming' : 'is-current'}`}>
          <span className="vacation-popup-date-ico" aria-hidden="true">📅</span>
          <div className="vacation-popup-date-text">
            <span className="vacation-popup-date-label">{isUpcoming ? 'Fermeture prévue' : 'Retour prévu'}</span>
            <span className="vacation-popup-date-value">{dateLabel}</span>
          </div>
        </div>
        {isUpcoming && (
          <a href="tel:0624314434" className="vacation-popup-urgence">
            📞 Urgence ? 06 24 31 44 34
          </a>
        )}
        {banner.cta_enabled !== 0 && (
          <a href="tel:0624314434" className="vacation-popup-urgence">
            📞 Urgence quand même ? 06 24 31 44 34
          </a>
        )}
        <button className="vacation-popup-visit" onClick={onClose}>
          Visiter le site quand même →
        </button>
      </div>
    </div>
  );
}
